import { HeaderOptionsLeft } from './HeaderOptionsLeft'
import { HeaderOptionsRight } from './HeaderOptionsRight'
import { WorkspaceSwitcher } from './WorkspaceSwitcher'

const Header = () => {
  return (
    <div className="studio--header">
      <HeaderOptionsLeft />
      <WorkspaceSwitcher />
      <HeaderOptionsRight />
    </div>
  )
}

export default Header
